export default {"src":"/_next/static/media/inventory.6d740b12.gif","height":940,"width":1456,"blurWidth":0,"blurHeight":0};